import angular from 'angular';
import uiRouter from 'angular-ui-router';
import executivesummaryPOCComponent from './executivesummary.poc.component';

let executivesummaryPOCModule = angular.module('executivesummaryPOC', [
  uiRouter
])

.component('executivesummarypoc', executivesummaryPOCComponent);

export default executivesummaryPOCModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary_poc/executivesummary.poc.js